<div class="container-fluid">
    <button id="btnView" class="btn btn-primary" style="width: 0px; visibility:hidden;" aria-hidden="true" data-toggle="modal" data-target="#exampleModalLong"></button>
    <div class="card border-light shadow-sm">
        <label><strong>Document Uploads</strong><span class="txt-max"> Max file size {{maxMB}}MB
                {{dtype}}</span></label>
        <div class="row">

            <div class="col-md-12">
                <div class="warnig-text" *ngIf="linkedDocs.length > 0 || uploadedDocs.length>0">
                    When submitting copies of letters, documents or contracts in support of an application, please ensure that they are clear and legible. Documents that are not clear will not be accepted as supporting evidence. All foreign documents must be translated by
                    a certified translator into English.
                </div>
                <table id="vTypes">
                    <!-- <thead class="thead-inverse tbl-hd-stl hgt-btn">
            <tr style="vertical-align:middle;" class="hgt-btn">
              <th>
                Document Type
              </th>
              <th style="vertical-align:middle;">
                File Name
              </th>
            </tr>
          </thead> -->
                    <tr *ngFor="let UserDocument of uploadedDocs">
                        <td><span class="tbl-td">{{UserDocument.description}}</span></td>
                        <td></td>
                        <td class="bdr">{{UserDocument.file_name}}</td>
                        <td>
                            <ng-container>
                                <button title="Delete Document" *ngIf="isProcess && !(isAnnualCompliance && isView)" style="margin: 0%" class="btn btn-danger btn-sm" (click)="deleteDoc(UserDocument)"><i class="fa fa-trash-o fa-fw"></i></button>
                                <button title="View Document" style="margin: 0%" class="btn btn-success btn-sm"><i
                                        class="fa fa-eye" aria-hidden="true" data-toggle="modal"
                                        data-target="#exampleModalLong"
                                        (click)="viewDoc(UserDocument.shareId,UserDocument.document_link)"></i></button>

                                <button title="Upload another of the same type" *ngIf="UserDocument.multiple_allowed == true && !isAmendRoute" style="margin: 0%" class="btn btn-primary btn-sm"><i class="fa fa-plus" aria-hidden="true"
                                        (click)="extraDoc(UserDocument)"></i></button>
                            </ng-container>
                        </td>
                        <td></td>

                    </tr>
                    <tfoot>
                        <ng-container *ngIf="(isProcess)  || dataCntrl.status == '2'">

                            <ng-container *ngFor="let docType of linkedDocs">
                                <tr>



                                    <td> <span class="tbl-td"> {{docType.description}}<a
                                                *ngIf="docType.is_mandatory == true"><a
                                                    class="red-asterik"> *</a></a></span> </td>
                                    <td style="padding-right: 20px;">
                                        <select #vehicleSelect class="form-control form-control-sm" style="width: 160px;" *ngIf="checkDocType(docType)" (change)="onVehicleSelectChange(vehicleSelect,docType)">
                                            <option value="" selected>Select Vehicle</option>
                                            <option *ngFor="let app_vehicle of dataCntrl.vehicles" class="app-option"
                                                [value]="app_vehicle.id">
                                                {{app_vehicle.registration_number}}
                                                <!-- {{app_vehicle.registration_number}}, {{app_vehicle.vehicle_type}}, {{app_vehicle.vehicle_make}} -->
                                            </option>
                                        </select>
                                    </td>
                                    <td class="bdr"></td>
                                    <td style="padding-top: 7px; padding-left: 5px">
                                        <label class="btn fileUpload btn-default" *ngIf="isKiosk == false" style="border-radius: 4px; width: 120px; height: 40px; background-color:#1d3f94; color:white;">Choose
                                            File
                                            <input style="display:none" onclick="this.value=''" id="fileupload"
                                                #fileupload type="file"
                                                (change)="handleFileInput($event,docType.document_type_id)" />
                                        </label>

                                        <button *ngIf="isKiosk == true" class="btn fileUpload btn-default btn btn-md m-clr hd-btn" (click)="scanDocument(docType.document_type_id)" title="Scan">Scan</button>

                                        <!-- <input    id="fileupload" #fileupload type="file" (change)="handleFileInput($event,docType.document_type_id)" /> -->
                                    </td>

                                </tr>
                            </ng-container>
                            <!-- <ng-container *ngIf="isAmendRoute">
              <ng-container *ngFor="let docType of linkedDocs">
              <tr *ngIf="docType.code=='Aff_AMEND' || docType.code == 'AFF_DUP'">



                <td> <span class="tbl-td"> {{docType.description}}<a *ngIf="docType.is_mandatory == true"><a class="red-asterik"> *</a></a></span> </td>
                <td style="padding-right: 20px;">
                  <select #vehicleSelect class="form-control form-control-sm" style="width: 300px;" *ngIf="checkDocType(docType)" (change)="onVehicleSelectChange(vehicleSelect,docType)">
                    <option value="" selected>Select Vehicle</option>
                    <option *ngFor="let app_vehicle of dataCntrl.vehicles" class="app-option" [value]="app_vehicle.id">
                      {{app_vehicle.registration_number}}, {{app_vehicle.vehicle_type}}, {{app_vehicle.vehicle_make}}
                    </option>
                  </select>
                </td>
                <td class="bdr"></td>
                <td>
                  <input  [disabled]="isDuplicateMode"  id="fileupload" #fileupload type="file" (change)="handleFileInput($event,docType.document_type_id)" />
                </td>

              </tr>
              </ng-container> -->

                            <tr *ngIf="UserDocuments.length > 4">
                                <td colspan="4" class="rm-brd">
                                    <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;">
                                    </pagination-controls>
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="uploadedDocs.length <= 0">
                            <td colspan="4" class="rm-brd">
                                <span class="text-info text-small">No Documents found.</span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <!--<div class="col-12">
      <button title="Close this page" (click)="utility.landingPage()" type="button" id="btnClose" class="btn btn-md btn-primary pull-right" style="width:18%; margin-left:10px; "><i class="fa fa-window-close-o"></i> Close</button>
      <button title="Go to the next page" *ngIf="utility.ctrlPages[acc.Fourth].next > -1" type="button" id="btnNext" (click)="utility.nextPage(acc.Fourth)" class="btn btn-md btn-success pull-right" style="width:18%; margin-left:10px; ">Submit <i class="fa fa-arrow-circle-right"></i></button>
      <button title="Save change(s)" type="submit" [disabled]="DocTypesList.length > 0" id="btnSave" class="btn btn-md btn-primary pull-right" style="width:18%; margin-left:10px; "><i class="fa fa-save"></i> Save</button>
      <button *ngIf="utility.ctrlPages[acc.Fourth].previous > -1" title="Go to previous carrier account page" type="button" id="btnPrevious" (click)="utility.prevPage(acc.Fourth)" class="btn btn-md btn-info pull-right" style="width:18%; margin-left:10px; "><i class="fa fa-arrow-circle-left"></i> Previous</button>
    </div>-->

        </div>
    </div>
</div>


<div class="col-12" *ngIf="!(isAnnualCompliance && isView) && isProcess || dataCntrl.status == '2'">
    <button class="btn btn-md m-clr pull-right hd-btn mt-2 ml-2" [disabled]="disableBtn" (click)="backToTab()" title="Back" style="float: left !important;">Back</button>
    <ng-container *ngIf="isProcess || dataCntrl.status == '2'">
        <button class="btn btn-md m-clr pull-right hd-btn mt-2" [disabled]="disableBtn" (click)="cancelApplication()" title="Cancel" style="float: right !important;">Cancel</button>
        <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="saveUploads()" title="Save & Continueto step 6" [disabled]="disableBtn" style="float: right !important;">
            Save & Continue</button>
    </ng-container>
    <div *ngIf="disableBtn">
        <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" routerLink="/permit/approval" title="Cancel" style="float: right !important;">
            Back</button>
    </div>
</div>

<div class="col-12" *ngIf="isAnnualCompliance && isView">
    <button class="btn btn-md m-clr pull-right hd-btn mt-2 ml-2" (click)="backToTab()" title="Back" style="float: left !important;">Back</button>
    <ng-container *ngIf="isProcess || dataCntrl.status == '2'">
        <button class="btn btn-md m-clr pull-right hd-btn mt-2" (click)="cancelApplication()" title="Cancel" style="float: right !important;">Cancel</button>
        <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="saveUploads()" title="Next" style="float: right !important;">
            Next</button>
    </ng-container>

</div>



<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Document Upload</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body modal-lg">

                <div style="width: 99%; height: 600px;" *ngIf="!isPromptUserToScan">

                    <!-- <pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [render-text]="true" style="display: block;" [original-size]="false" [autoresize]="true"></pdf-viewer> -->
                    <ng2-pdfjs-viewer     *ngIf="pdfSrc" [pdfSrc]='pdfSrc'         
            id='view2'             
          [externalWindow]="false"
          [downloadFileName]="'mytestfile.pdf'"                  
          [openFile]="false"
          [viewBookmark]="false"
          [download]="false" >
        </ng2-pdfjs-viewer>
                    <img [src]="img" *ngIf="img">
                    <ngx-loading [show]="isLoadingImg"></ngx-loading>
                </div>

                <div style="width: 99%; min-height: 470px;" class="text-center" *ngIf="isPromptUserToScan">
                    <img src="/assets/Photocopy.gif" class="text-center" />
                    <p>{{scannerMessage}}</p>
                </div>

            </div>
            <div class="modal-footer">
                <div *ngIf="!isPromptUserToScan && isKiosk">
                    <button type="button" *ngIf="!isViewMode" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="callTheScanner()">Rescan</button>
                    <button type="button" *ngIf="!isViewMode" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="postScannedDoc()">Accept</button>
                </div>
                <div *ngIf="isPromptUserToScan">
                    <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="callTheScanner()">Scan</button>
                </div>
                <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="cancelScanner()" data-dismiss="modal">Cancel</button>
                <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
            </div>
        </div>
    </div>










    <div class="modal fade" id="addModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Upload Document</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body modal-lg">
                    <table>
                        <th>
                            Document Type
                        </th>



                        <tbody>
                            <tr>
                                <td>
                                    <select class="form-control select-auto" [(ngModel)]="docTypeData" (change)="selectedDocType($event.target.value);isTrue = true" [ngStyle]="{'border-color': haserror && 'red'}" title="Document Code">
                                        <option *ngFor="let type of categories" [ngValue]="type.id" disabled>Select
                                            Document Type</option>
                                        <option *ngFor="let type of doctypesCodes" [ngValue]="type">{{type.description}}
                                        </option>


                                    </select>
                                </td>
                                <td>
                                    <div>
                                        <!-- <label for="file">Choose File</label> -->
                                        <!-- <input [disabled]="!isTrue" class="form-control" type="file"
                     id="file"
                     (change)="handleFileInput($event)"> -->
                                    </div>
                                </td>
                                <!-- <td>
            <button type="button"><i
              class="fa fa-eye" aria-hidden="true" (click)="viewDoc(item.shareId,item.document_link)"></i></button>

          </td> -->
                            </tr>
                        </tbody>

                    </table>
                    <ngx-loading [show]="isLoadingImg"></ngx-loading>

                </div>
                <div class="modal-footer" *ngIf="isProcess || dataCntrl.status == '2'">
                    <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" data-dismiss="modal">Close</button>
                    <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                </div>
            </div>
        </div>
    </div>


    <!-- <ngx-loading [show]="isLoading"></ngx-loading> -->
    <div class="col-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
    </div>
